import React from 'react';
interface statusProps {
  status: string;
}
const Status: React.FC<statusProps> = ({ status }) => {
  let content = '';
  if (status === 'Deactivate') {
    content = 'Deactivate';
  } else if (status) {
    content = 'active';
  } else {
    content = 'Suspended';
  }

  return (
    <div className={`user_management_status-data ${content}`}>{content}</div>
  );
};

const MemoizedComponent = React.memo(Status);
export default MemoizedComponent;
